import React, { useEffect, useState } from "react";
import { AlertTriangle, X, MessageCircle, Bell } from "lucide-react";
import api from "./api";

export default function AlertsBanner({ visible = true }) {
  const [lowStock, setLowStock] = useState([]);
  const [overduePlans, setOverduePlans] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/admin/materials").then(r => {
      const low = (r.data || []).filter(m => (m.quantity || 0) <= (m.min_stock || 0));
      setLowStock(low);
    }).catch(()=>{});
    api.get("/admin/plans").then(r => {
      setOverduePlans((r.data || []).filter(p => p.status === "atrasada" && p.active));
    }).catch(()=>{});
  }, []);

  if (dismissed || !visible) return null;
  if (lowStock.length === 0 && overduePlans.length === 0) return null;

  return (
    <div className="mb-6 card-arya p-5 border-l-4 border-[color:var(--danger)] bg-[rgba(179,58,58,0.05)]" data-testid="alerts-banner">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-full bg-[rgba(179,58,58,0.12)] text-[color:var(--danger)]">
          <Bell size={16}/>
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <p className="font-serif text-lg text-[color:var(--danger)]">Alertas importantes</p>
            <button onClick={()=>setDismissed(true)} className="p-1 text-[color:var(--ink-500)]" data-testid="btn-dismiss-alerts"><X size={14}/></button>
          </div>
          <div className="mt-2 grid md:grid-cols-2 gap-3 text-sm">
            {lowStock.length > 0 && (
              <div>
                <div className="inline-flex items-center gap-2 text-[color:var(--danger)] font-semibold">
                  <AlertTriangle size={14}/> {lowStock.length} material(is) precisando repor
                </div>
                <ul className="mt-1 text-[color:var(--ink-500)] text-xs list-disc pl-5">
                  {lowStock.slice(0,5).map(m=>(<li key={m.material_id}>{m.name} — {m.quantity} {m.unit}</li>))}
                </ul>
              </div>
            )}
            {overduePlans.length > 0 && (
              <div>
                <div className="inline-flex items-center gap-2 text-[color:var(--danger)] font-semibold">
                  <MessageCircle size={14}/> {overduePlans.length} plano(s) com mensalidade atrasada
                </div>
                <ul className="mt-1 text-[color:var(--ink-500)] text-xs list-disc pl-5">
                  {overduePlans.slice(0,5).map(p=>(<li key={p.plan_id}>{p.client_name} — {p.plan_type}, vence {p.next_billing}</li>))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
